const Colors = {
  primary: "indigo",
  secondary: "slate",
  success: "green",
  danger: "red",
  warning: "orange",
  info: "blue",
  neutral: "gray",
};

export const getColor = (variant) => Colors[variant];

export const getColorClass = (variant) => `color-${getColor(variant)}-600`;

export const getBackgroundColorClass = (variant) =>
  `bg-${getColor(variant)}-500`;
